<template>
  <div class="flex flex-grow">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PipelineLayoutTab",
};
</script>
